module.exports = {
  __depends__: [
    require(229)
  ],
  __init__: [ 'bpmnSearch'],
  bpmnSearch: [ 'type', require(83) ]
};
